import { fattribs, fpoints } from "./format";
export const polyline = (pts, attribs, ...body) => [
    "polyline",
    fattribs(Object.assign({ fill: "none", points: fpoints(pts) }, attribs)),
    ...body,
];
